import type { IconData } from '@stacksjs/iconify-core'

export const otherUiPenTool: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 0a8 8 0 0 1 8 8h-4v2a6 6 0 0 1-6 6H1.06l4.551-4.55q.187.049.389.05a1.5 1.5 0 1 0-1.45-1.111L0 14.939V10a6 6 0 0 1 6-6h2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiPenTool
